import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./app/App.tsx";
import "./styles/index.css";

Sentry.init({
  dsn: "https://5432845f3c10f22852451642cb56f928@o4511411516211200.ingest.us.sentry.io/4511411536265216",
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  sendDefaultPii: true,
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD,
});

createRoot(document.getElementById("root")!).render(<App />);
